import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { TokenLogService } from "../_services/tokenLogService";
import { Guid } from "../utils/guid";
import { LogEntry } from "../_models/logEntry";

@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.css"],
})
export class HomePageComponent implements OnInit {
  constructor(
    private titleService: Title,
    public router: Router,
    private tokenLogService: TokenLogService
  ) {}

  sessionId: string;
  headerSrc: string;
  displaySignUpButton = false;

  ngOnInit() {
    localStorage.removeItem("firstRegistrationDetails");
    localStorage.removeItem("registrationDetails");
    localStorage.removeItem("setContractPage");
    localStorage.removeItem("clientCenterNumber");

    const hostname: string = window.location.hostname.toLocaleLowerCase();
    console.log(hostname);
    if (hostname.includes("appfolioportal") || hostname.includes("localhost")) {
      this.router.navigate(["appfolio"], {
        queryParams: {
          vhost: this.router.parseUrl(this.router.url).queryParams["vhost"],
        },
      });
    } else {
      this.sessionId = Guid.newGuid();
      localStorage.setItem("sessionId", this.sessionId);
      this.checkForToken();
    }
  }

  setPageTitle(title: string) {
    this.titleService.setTitle(title);
  }

  checkForToken() {
    const token = this.router.parseUrl(this.router.url).queryParams["token"];
    if (token) {
      setTimeout(() => {
        const companyName = localStorage.getItem("companyName");
        const contactName = localStorage.getItem("contactName");
        const email = localStorage.getItem("email");
        const phone = localStorage.getItem("phone");
        const logEntry: LogEntry = {
          pageNumber: 1,
          companyName: companyName,
          vendorClientUniqueId: localStorage.getItem("vendorClientUniqueId"),
          message:
            "Session time out - redirected to timeout page after 60 minutes",
          exception: null,
          clientId: "",
          clientSecret: "",
          email: email,
          phone: phone,
          contactName: contactName,
          sessionId: this.sessionId,
          password: null,
          companyLegalName: null,
          numberOfProperties: 0,
          numberOfUnits: 0,
          street1: null,
          city: null,
          state: null,
          zipCode: null,
          country: null,
          settlementAuth: null,
          clientVendorId: 1,
        };
        this.tokenLogService
          .logEntry(logEntry)
          .toPromise()
          .then(
            () => {
              console.log("Token entry set correctly");
            },
            (error) => {
              console.log(
                "An error has occurred while creating log entry: ",
                error
              );
            }
          );
        this.router.navigateByUrl("timeout");
      }, 60 * 60 * 1000);
      let sessionStart = new Date();
      localStorage.setItem("sessionStart", sessionStart.toISOString());
      this.headerSrc = "assets/images/RI_Buildium-SignUp-Header2.png";
      this.displaySignUpButton = true;
      const decodedJWT = JSON.parse(window.atob(token.split(".")[1]));
      localStorage.setItem("token", token);
      localStorage.setItem("vendorClientUniqueId", decodedJWT.accountId);
      this.setInitialClientData(token);
    } else {
      this.headerSrc = "assets/images/RI_Buildium-Header.png";
      this.displaySignUpButton = false;
      this.setInitialClientData(null);
    }
  }

  setInitialClientData(token: string) {
    localStorage.setItem("clientId", "");
    localStorage.setItem("clientSecret", "");
    let phone: string;
    if (token) {
      this.tokenLogService
        .getClientInfo(token)
        .toPromise()
        .then(
          (result: any) => {
            localStorage.setItem("companyName", result.companyName);
            localStorage.setItem(
              "contactName",
              result.firstName + " " + result.lastName
            );
            localStorage.setItem("email", result.email);
            if (
              result &&
              result.phoneNumbers &&
              result.phoneNumbers.length > 0
            ) {
              localStorage.setItem("phone", result.phoneNumbers[0].number);
              phone = result.phoneNumbers[0].number;
              localStorage.setItem("phone", result.phoneNumbers[0].number);
            } else {
              localStorage.setItem("phone", "");
              phone = "";
            }
            // logging first client approach
            const logEntry: LogEntry = {
              pageNumber: 1,
              companyName: result.companyName,
              vendorClientUniqueId: localStorage.getItem(
                "vendorClientUniqueId"
              ),
              message: "First client approach",
              exception: null,
              clientId: "",
              clientSecret: "",
              email: result.email,
              phone: phone,
              contactName: result.firstName + " " + result.lastName,
              sessionId: this.sessionId,
              password: null,
              companyLegalName: null,
              numberOfProperties: 0,
              numberOfUnits: 0,
              street1: null,
              city: null,
              state: null,
              zipCode: null,
              country: null,
              settlementAuth: null,
              clientVendorId: 1,
            };
            this.tokenLogService
              .logEntry(logEntry)
              .toPromise()
              .then(
                () => {
                  console.log("Token entry set correctly");
                },
                (error) => {
                  console.log(
                    "An error has occurred while creating log entry: ",
                    error
                  );
                }
              );
          },
          (error) => {
            console.log(
              "An error has occurred while getting client credentials: ",
              error
            );
            const logEntry: LogEntry = {
              pageNumber: 1,
              companyName: "",
              vendorClientUniqueId: null,
              message: "An error has occurred while getting client credentials",
              exception: error,
              clientId: "",
              clientSecret: "",
              email: "",
              phone: phone,
              contactName: "",
              sessionId: this.sessionId,
              password: null,
              companyLegalName: null,
              numberOfProperties: 0,
              numberOfUnits: 0,
              street1: null,
              city: null,
              state: null,
              zipCode: null,
              country: null,
              settlementAuth: null,
              clientVendorId: 1,
            };
            this.tokenLogService
              .logEntry(logEntry)
              .toPromise()
              .then(
                () => {
                  console.log("Token entry set correctly");
                },
                (error) => {
                  console.log(
                    "An error has occurred while creating log entry: ",
                    error
                  );
                }
              );
          }
        );
    } else {
      localStorage.setItem("companyName", "");
      localStorage.setItem("contactName", "");
      localStorage.setItem("email", "");
      localStorage.setItem("phone", "");
      localStorage.setItem("email", "");
      // logging first client approach
      const logEntry: LogEntry = {
        pageNumber: 1,
        companyName: "",
        vendorClientUniqueId: null,
        message: "First client approach, token is not present",
        exception: null,
        clientId: "",
        clientSecret: "",
        email: "",
        phone: phone,
        contactName: "",
        sessionId: this.sessionId,
        password: null,
        companyLegalName: null,
        numberOfProperties: 0,
        numberOfUnits: 0,
        street1: null,
        city: null,
        state: null,
        zipCode: null,
        country: null,
        settlementAuth: null,
        clientVendorId: 1,
      };
      this.tokenLogService
        .logEntry(logEntry)
        .toPromise()
        .then(
          () => {
            console.log("Token entry set correctly");
          },
          (error) => {
            console.log(
              "An error has occurred while creating log entry: ",
              error
            );
          }
        );
    }
  }

  signInButton() {
    window.open("https://cp.hunterwarfield.com/login");
  }
}
